import { render, staticRenderFns } from "./attorney-contact.vue?vue&type=template&id=71d71908"
import script from "./attorney-contact.vue?vue&type=script&lang=js"
export * from "./attorney-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports